var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "entypo:archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9621 4H12.0361C12.0361 4 10.0441 4 10.0441 6H29.9541C29.9541 4 27.9621 4 27.9621 4ZM33.9361 10C33.9361 8 31.9461 8 31.9461 8H8.05414C8.05414 8 6.06414 8 6.06414 10V12H33.9361V10ZM37.9161 12L36.7401 10.816V14H3.26014V10.816L2.08214 12C0.904142 13.184 0.0601422 13.5 0.534142 16C1.00614 18.492 3.29214 32.152 3.63214 34C4.00414 36.028 6.06614 36 6.06614 36H33.9381C33.9381 36 35.9981 36.028 36.3721 34C36.7121 32.152 38.9961 18.492 39.4701 16C39.9401 13.5 39.0961 13.184 37.9161 12ZM28.0001 23.994C28.0001 25.102 27.1021 26 25.9941 26H14.0061C13.4741 26 12.9639 25.7887 12.5877 25.4125C12.2115 25.0363 12.0001 24.526 12.0001 23.994V20H14.0001V24H26.0001V20H28.0001V23.994Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveicon);
export default __webpack_public_path__ + "static/media/Archiveicon.d6ff2b96b7d35c4c27a1598bccdcb94a.svg";
export { ForwardRef as ReactComponent };